import { type FC } from 'react'
import { MessagePanel } from '../../../components/MessagePanel/MessagePanel'
import { Modal } from '../../../components/Modal/Modal'

interface ArchiveBookingDialogProps {
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ArchiveBookingDialog: FC<ArchiveBookingDialogProps> = ({ isLoading = false, onConfirm, onCancel }) => (
  <Modal
    show
    footerClassName='p-4 pt-0'
    onHide={onCancel}
    header={<h5 className='mb-0'>Archiving this booking?</h5>}
    headerBodySeparator
    body={
      <div className='d-flex flex-column gap-4'>
        <span className='paragraph-medium'>This booking moves to history, where you can recreate it with a new link.</span>
        <MessagePanel
          variant='warning'
          message={<span>This booking link stops working and can&apos;t be restored. Anyone who received it won&apos;t be able to book through it.</span>}
        />
      </div>
    }
    showFooterActions
    footerPrimaryActionTitle='Archive booking'
    footerPrimaryActionLoading={isLoading}
    footerSecondaryActionTitle='Cancel'
    onFooterPrimaryAction={onConfirm}
    onFooterSecondaryAction={onCancel}
  />
)
